import React from "react";
import { DocumentRenderer } from "components";
import { Trans } from "react-i18next";
import LineItems from "./LineItems";
import withData from "./withData";
import CurrencyConversion from "./CurrencyConversion";
import MainHeader from "./MainHeader";
import HeaderData from "./HeaderData";

const _QuoteDocument = ({
  item,
  contact,
  settings,
  organisation,
  history,
  taxRates,
  t,
  qrCode,
  ...props
}) => (
  <DocumentRenderer {...props}>
    <div className="container-fluid my-3" >
      <MainHeader item={item} company={organisation} client={contact} taxRates={taxRates} t={t} settings={settings} doc_name={'Quote'} logo={props.selectedOrganisation.logo} hideAttention={true}>
        <HeaderData className="mb-1" label={`Date`} value={item.DateString} />
        <HeaderData className="mb-1" label={`Time`} value={item.UpdatedDateUTC.split('T')[1].substr(0, 8)} />
        <HeaderData className="mb-1" label="Quote Number" value={item.QuoteNumber} />
        <HeaderData className="mb-1" label="Reference" value={item.Reference} />
        <HeaderData className="mb-1" label="Expiry" value={item.ExpiryDateString} />
      </MainHeader>
      {item.Title ? (
        <h3 style={{ whiteSpace: "pre-line" }}>{item.Title}</h3>
      ) : null}
      {item.Summary ? (
        <p style={{ whiteSpace: "pre-line" }}>{item.Summary}</p>
      ) : null}
      <LineItems invoice={item} taxRates={taxRates} includeDiscount lang={props.language} history={history} organisation={organisation}/>
      {item.Terms ? (
        <>
          <h3
            style={{ whiteSpace: "pre-line", borderBottom: "1px solid black" }}
          >
            <Trans>Terms</Trans>
          </h3>
          <p style={{ whiteSpace: "pre-line" }}>{item.Terms}</p>
        </>
      ) : null}
    </div>
  </DocumentRenderer>
);

export const QuoteDocument = withData(_QuoteDocument);
